import { EventEmitter, ViewContainerRef } from '@angular/core';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { InputFilterComponent } from './input-filter.component';
import { FilterMatchMode } from 'primeng/api';
import { FilterComponentFactory } from '@irian-ro/table-column-filter';

export interface InputOptions {
  props?: {
    value?: string;
  };
  filterMatchMode?: string;
  filterChangeEvent?: EventEmitter<FilterMetadata>;
}

export const textInputFactory: FilterComponentFactory<InputFilterComponent> = {
  createInstance: (container: ViewContainerRef) => {
    return container.createComponent<InputFilterComponent>(InputFilterComponent).instance;
  },

  bindProps: (instance: InputFilterComponent, options?: InputOptions) => {
    instance.value.set(options?.props?.value ? options.props?.value : '');
    instance.filterMatchMode = options?.filterMatchMode ? options?.filterMatchMode : FilterMatchMode.CONTAINS;
  },

  subscribeToChanges: (instance: InputFilterComponent, options?: InputOptions) => {
    instance.filtersChange.subscribe((filterMetadata: FilterMetadata) => {
      if (options?.filterChangeEvent) {
        options.filterChangeEvent.emit(filterMetadata);
      }
    });
  },
};
